import { render, staticRenderFns } from "./AttachImage.vue?vue&type=template&id=32346d9b&scoped=true&"
import script from "./AttachImage.vue?vue&type=script&lang=js&"
export * from "./AttachImage.vue?vue&type=script&lang=js&"
import style0 from "./AttachImage.vue?vue&type=style&index=0&id=32346d9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32346d9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32346d9b')) {
      api.createRecord('32346d9b', component.options)
    } else {
      api.reload('32346d9b', component.options)
    }
    module.hot.accept("./AttachImage.vue?vue&type=template&id=32346d9b&scoped=true&", function () {
      api.rerender('32346d9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/Components/admin/AttachImage.vue"
export default component.exports